import React from 'react'
import PropTypes from 'prop-types'

export const InputWithRedux = InputComponent => {
  const WrappedInputComponent = ({ input, meta, ...props }) => {
    const value = input.value || props.value
    const onChangeHandler = input.onChange || props.onChange
    const onBlurHandler = input.onBlur || props.onBlur
    const { error, touched } = meta
    const errored = touched && !!error

    return (
      <InputComponent
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        value={value}
        errored={errored}
        errorText={error}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    )
  }

  WrappedInputComponent.propTypes = {
    inputComponent: PropTypes.node,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),
    value: PropTypes.string,
    input: PropTypes.shape({
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      value: PropTypes.oneOfType([
        PropTypes.shape({
          value: PropTypes.string,
          name: PropTypes.string,
        }),
        PropTypes.string,
      ]),
    }),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }

  return WrappedInputComponent
}

InputWithRedux.propTypes = {
  inputComponent: PropTypes.node,
}
